import { useEffect, useState } from "react";
import { Download, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, BACKEND_URL } from "@/lib/api";

export default function AdminLeads() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/leads").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this lead?")) return;
    await api.delete(`/admin/leads/${id}`);
    toast.success("Deleted");
    load();
  };

  const exportCsv = async () => {
    const token = localStorage.getItem("tara_token");
    const res = await fetch(`${BACKEND_URL}/api/admin/leads/export`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) { toast.error("Export failed"); return; }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `leads-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const fmt = (d) => { try { return new Date(d).toLocaleString("en-IN", { hour12: true }); } catch { return d; } };

  return (
    <div data-testid="admin-leads">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h1 className="heading-xl text-3xl">LEADS</h1>
        <button onClick={exportCsv} className="btn-primary text-sm" data-testid="admin-leads-export">
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>

      <div className="bg-white border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              {["Date", "Name", "Email", "Phone", "Subject", "Source", "Message"].map((c) => (
                <th key={c} className="text-left px-4 py-3 text-[10px] uppercase tracking-widest">{c}</th>
              ))}
              <th className="w-12"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan="8" className="px-4 py-8 text-center text-gray-500">Loading...</td></tr>
              : items.length === 0 ? <tr><td colSpan="8" className="px-4 py-8 text-center text-gray-500">No leads yet.</td></tr>
              : items.map((l) => (
                <tr key={l.id} className="border-t border-gray-100 hover:bg-gray-50" data-testid={`lead-row-${l.id}`}>
                  <td className="px-4 py-3 text-xs text-gray-500 whitespace-nowrap">{fmt(l.created_at)}</td>
                  <td className="px-4 py-3 font-semibold">{l.name || "—"}</td>
                  <td className="px-4 py-3">{l.email || "—"}</td>
                  <td className="px-4 py-3">{l.phone || "—"}</td>
                  <td className="px-4 py-3">{l.subject || "—"}</td>
                  <td className="px-4 py-3"><span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 ${l.source === "chatbot" ? "bg-[#FFCC00]" : "bg-gray-100"}`}>{l.source || "contact_form"}</span></td>
                  <td className="px-4 py-3 max-w-xs truncate" title={l.message}>{l.message || (l.interest && `Interest: ${l.interest}`) || "—"}</td>
                  <td className="px-4 py-3">
                    <button onClick={() => remove(l.id)} className="p-1.5 hover:bg-red-50 text-red-600" aria-label="Delete" data-testid={`lead-delete-${l.id}`}><Trash2 className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
